export default __webpack_public_path__ + "static/media/walkthrough-step1-fullHD.ca9db035.jpg";